export enum ParcelReportLotType {
	Built = "built",
	Agricultural = "agricultural",
	VacantOther = "vacantOther",
}

export enum ParcelReportMetric {
	MunicipalAssessment = "municipalAssessment",
	Area = "area",
	Frontage = "frontage",
	Dwellings = "dwellings",
	AgriculturalZone = "agriculturalZone",
}

interface ParcelReportProfile {
	metrics: readonly ParcelReportMetric[]
	includeBuildingDetails: boolean
	includeServicedVacantLand: boolean
}

const profiles: Record<ParcelReportLotType, ParcelReportProfile> = {
	[ParcelReportLotType.Built]: {
		metrics: [
			ParcelReportMetric.MunicipalAssessment,
			ParcelReportMetric.Area,
			ParcelReportMetric.Frontage,
			ParcelReportMetric.Dwellings,
		],
		includeBuildingDetails: true,
		includeServicedVacantLand: false,
	},
	[ParcelReportLotType.Agricultural]: {
		metrics: [ParcelReportMetric.Area, ParcelReportMetric.MunicipalAssessment, ParcelReportMetric.AgriculturalZone],
		includeBuildingDetails: false,
		includeServicedVacantLand: true,
	},
	[ParcelReportLotType.VacantOther]: {
		metrics: [ParcelReportMetric.Area, ParcelReportMetric.Frontage, ParcelReportMetric.MunicipalAssessment],
		includeBuildingDetails: false,
		includeServicedVacantLand: true,
	},
}

export function parcelReportLotType(assetType: unknown, assetCategory: unknown): ParcelReportLotType {
	if (assetType === "built") return ParcelReportLotType.Built
	if (assetCategory === "LAND_AGR") return ParcelReportLotType.Agricultural
	return ParcelReportLotType.VacantOther
}

export function parcelReportProfile(assetType: unknown, assetCategory: unknown): ParcelReportProfile {
	return profiles[parcelReportLotType(assetType, assetCategory)]
}
